import {Component, OnInit, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import {FormBuilder, FormControl} from '@angular/forms';
import {DomainService} from '../../../../services/domain.service';
import {Domain, IDomain} from '../../../../models/domain.model';
import { Validation } from '../../error/error-messages/validator-messages';
import { nameValidator_v1 } from '../../validators/validator';

@Component({
  selector: 'app-domain',
  templateUrl: './domain.component.html',
  styleUrls: ['./domain.component.scss']
})
export class DomainComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;
  constructor(private fb: FormBuilder, private domainService: DomainService) { }

  // @ts-ignore
  domain: Domain[] = [];

  // @ts-ignore
  currentDomain: IDomain = [];
  sorted1 = false;

  /*
  -----------------------------         for all page attribute    --------------------------------
  */
  search: any;
  page = 1;
  perPage = 10;
  /*
  end for all page
   */


  editForm = this.fb.group({
    name: new FormControl('', {validators: nameValidator_v1('Le nom ',2,100), updateOn: 'change'}),
    description: new FormControl('', [ Validation.descriptionValidator("La description"),])
  });

  domainForm = this.fb.group({
    name: new FormControl('',{validators: nameValidator_v1('Le nom ',2,100), updateOn: 'change'}),
    description: new FormControl('', [ Validation.descriptionValidator("La description"),])
  });

  ngOnInit(): void {
    this.loadDomain();
  }
  loadDomain = () => {
    this.domainService.getDomainAll()
      .subscribe((data: any) => {
        this.domain = data;
        }, (err) => {
       // console.log('-----> err', err);
      });
  }

  onEditDomain(id: any) {
    this.domainService.getidDomain(id).subscribe(rs => {
      this.currentDomain = rs;
      this.editForm = this.fb.group({
        id: new FormControl(this.currentDomain.id, [ ]),
        name: new FormControl(this.currentDomain.name, {validators: nameValidator_v1('Le nom ',2,100), updateOn: 'change'}),
        description: new FormControl(this.currentDomain.description, [Validation.descriptionValidator("La description")])
      });
    });
  }

  keyPressAlphanumeric(event) {
    const inp = String.fromCharCode(event.keyCode);

    if (!/[!ùç@#~µ¨$%°£§^&*$0-9()_+\=\[\]{};:"\\|,.<>\?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  normalizeString(str) {
    return str
      .toLowerCase()
      .replace(/[àáâãäå]/g, "a")
      .replace(/[ç]/g, "c")
      .replace(/[èéêë]/g, "e")
      .replace(/[ìíîï]/g, "i")
      .replace(/[ñ]/g, "n")
      .replace(/[òóôõö]/g, "o")
      .replace(/[ùúûü]/g, "u")
      .replace(/[ýÿ]/g, "y")
      .replace(/[^a-z0-9]/g, ""); // Supprime tous les caractères qui ne sont pas des lettres ou des chiffres
  }

  existingDomainName: string = '';
  onDomainFormSubmit() {
    const name = this.domainForm.get('name')?.value;
    const existingDomain = this.domain.find(d => this.normalizeString(d.name) === this.normalizeString(name));
    if(existingDomain){
      this.existingDomainName = 'Ce nom de domaine existe déjà! Veuillez réecrire un autre';
      return;
    }else{
      this.existingDomainName = '';
    }
    const domain: Domain = this.domainForm.value;

    this.domainService.saveDomain(domain).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le domaine a été ajouté avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadDomain();
      this.close();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez verifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }


  onEditFormSubmit() {
   // console.log(this.editForm.value);
    const domain: Domain = this.editForm.value;
    this.domainService.updateDomain(domain).subscribe(rs => {
      //console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le domaine a été modifié avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadDomain();
      this.close();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  deleteDomain(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ce domaine ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.domainService.deleteDomain(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Le domaine a été supprimé avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadDomain();
        }
      );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        })
      }
    })
  }



  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.perPage);
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.domain.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.domain.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  isSearch = false;
  searchFilter($event: KeyboardEvent) {
    this.isSearch = true;
    //console.log(this.search);
    this.domainService.getDomainAll().subscribe(data => {
      this.domain = data;
      this.domain = this.domain.filter(value =>
        value.name?.toLowerCase().trim().includes(this.search.toLowerCase().trim()) ||
        value.description?.toLowerCase().trim().includes(this.search.toLowerCase().trim())
      );
    }, (err) => {
      //console.log('-----> err', err);
    });
  }

  /*
  end for all page
   */
  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
    this.domainForm.patchValue({
      name: [''],
      description: ['']
    });
  }

  modifyCondition(value: string) {
    if (value === ''){
      this.existingDomainName = '';
    }
  }
}
